import React from 'react';
import { connect } from 'react-redux'
import { strings } from "../../../constants/strings";

class mobileFAQ extends React.Component {

  constructor(props) {
    super(props);
    
    var faqStructure = [];
    let fiveIsDone = false;
    var parsedString;
    for (let i = 5; ( ("Category_" + i +"_Name") in strings ); i++) {
      if(strings["Category_" + i + "_Name"] == ''){
        continue
      }
      if(fiveIsDone && i === 5){
        continue
      }
      for (let j = 1; j <= 25; j++)
      {
        if(strings["Category_" + i + "_Question_" + j] == '' || strings["Category_" + i + "_Question_" + j] == undefined){
          continue
        }
        const regexForQuestions = /\*(.*)\*(.*)/;
        const regexForHttps = /(https?:\/\/[^\s]+)/gm;
        let replacedStr = strings["Category_" + i + "_Question_" + j].replace(/\n/gm,'<br>')
        const parsedLinks = replacedStr.match(regexForHttps)
        if(parsedLinks != null){
           parsedLinks.map( (link) => {
            replacedStr = replacedStr.replace(link, "<a href=" + link + ">" + link + "</a>")
           })
          parsedString = replacedStr.match(regexForQuestions);
        }
        else {
          parsedString = replacedStr.match(regexForQuestions);
        }
          let categoryQuestion = {
                header: parsedString[1],
                body: parsedString[2]
              }
              faqStructure.push(categoryQuestion)
      }
      if(i === 5 && !fiveIsDone){
        i = 0
        fiveIsDone = true
      }
    }
    this.state = {faqStructure: faqStructure};
  }  

  render() {
    document.body.style.backgroundColor = "white";
    document.body.style.backgroundImage = "none";
    return (
      <>
        <ul id="posts">
          {this.state.faqStructure.map((question, index) => (
              <div key={"question" + index}>
              <strong>{question.header}</strong>
              <br/>
              <span dangerouslySetInnerHTML={{__html: question.body}}></span>
              <hr className='hrandroid'/>
            </div>
          ))}
        </ul>
      </>
    );
  }
}
export default connect(/*mapStateToProps, mapDispatchToProps*/)(mobileFAQ)